<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IdWrQ/images/cover.jpg?1685204506153" alt="This image is the cover for the book A Partial Sun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Partial Sun
      </h1>
      <p class="bookDescription body article font2">
        <b>Author Lawrence Reid Bechtel has captured the story of Isaac Granger, a slave from Thomas Jefferson's plantation as told through the eyes of amateur historian Reverend Charles Campbell.</b><br/><br/>In 1852, after much searching through the Black districts of Petersburg, Virginia, the amateur historian Charles Campbell finally located Isaac Granger, a former slave of the late Thomas Jefferson. Though disinterested at first in sharing his memories, Isaac was at last persuaded by the persistent Reverend to tell the full story of his time in Philadelphia as a young man in the early 1790s. It was supposed to have been a simple story: he would apprentice with a Quaker tinsmith and then return to Monticello to produce tinware for sale in such abundance that "Old Master" might pay down his plantation's crippling debts.<br/><br/> But Isaac was impressionable, and more thoughtful than Mr. Jefferson knew. Philadelphia was a big city, home to a thriving African-American community, and Isaac met all manner of characters, both tragic and comic. Isaac got himself into difficulties, contemplated his place in the world, and was challenged to do more than just serve. Conflict was inevitable.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Reid Bechtel
      </h2>
      
      <p class="authorDescription body article">Sculptor and author Lawrence Bechtel began his journey toward the writing of "A Slave in Philadelphia," his debut novel, with two bronze portrait sculptures: the first of Thomas Jefferson and the second of Isaac Granger, who had grown up as a slave at Monticello. During the course of this work, and the extensive research it involved, Lawrence read about Isaac's brief account of his time in Philadelphia as a tinsmith's apprentice and felt compelled, finally, to write a historical novel built from that account. This began with a long process of finding Isaac's voice, encouraged as he did so by the words of E.M. Forster from Howards End: "only connect." A former English teacher at Virginia Tech, book reviewer for The Roanoke Times, and creator of three CDs' worth of short stories, Lawrence is presently working on the sequel novel for this series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Boutique of Quality Books Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?288506f0